<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div v-if="$store.getters.tooltipBookId.hasOwnProperty(bookId)" >
    <v-tooltip v-if="util.tooltipCreate_EXPIRED($store.getters.tooltipBookId[bookId].book)"  bottom>
        <template slot="activator" slot-scope="{ on }">
            <v-icon class="pointer" color="warning" v-on="on">info</v-icon>
        </template>
        <span>{{util.tooltipMsg(1,$store.getters.tooltipBookId[bookId])}}</span>
    </v-tooltip>

    <v-tooltip v-if="util.tooltipCreate_DELIVERED_FALSE($store.getters.tooltipBookId[bookId].book)"  bottom>
        <template slot="activator" slot-scope="{ on }">
            <v-icon class="pointer" color="warning" v-on="on">info</v-icon>
        </template>
        <span>{{util.tooltipMsg(2,$store.getters.tooltipBookId[bookId])}}</span>
    </v-tooltip>

    <v-tooltip v-if="util.tooltipCreate_DELIVERED($store.getters.tooltipBookId[bookId].book)"  bottom>
        <template slot="activator" slot-scope="{ on }">
            <v-icon class="pointer" color="red accent-4" v-on="on">info</v-icon>
        </template>
        <span>{{util.tooltipMsg(3,$store.getters.tooltipBookId[bookId])}}</span>
    </v-tooltip>

    <v-tooltip v-if="util.tooltipCreate_IN_LIBRARY($store.getters.tooltipBookId[bookId].book)"  bottom>
        <template slot="activator" slot-scope="{ on }">
            <v-icon class="pointer" color="red accent-4" v-on="on">info</v-icon>
        </template>
        <span>{{util.tooltipMsg(4,$store.getters.tooltipBookId[bookId])}}</span>
    </v-tooltip>

    <v-tooltip v-if="util.tooltipCreate_RETURNED_IN_DP($store.getters.tooltipBookId[bookId].book)"  bottom>
        <template slot="activator" slot-scope="{ on }">
            <v-icon class="pointer" color="warning" v-on="on">info</v-icon>
        </template>
        <span>{{util.tooltipMsg(5,$store.getters.tooltipBookId[bookId])}}</span>
    </v-tooltip>

    <v-tooltip v-if="util.tooltipCreate_EXCHANGED($store.getters.tooltipBookId[bookId].book)"  bottom>
        <template slot="activator" slot-scope="{ on }">
            <v-icon class="pointer" color="warning" v-on="on">info</v-icon>
        </template>
        <span>{{util.tooltipMsg(6,$store.getters.tooltipBookId[bookId])}}</span>
    </v-tooltip>

        <v-tooltip v-if="util.tooltipGotVoucherOrPicked_up($store.getters.tooltipBookId[bookId].book)"  bottom>
            <template slot="activator" slot-scope="{ on }">
                <v-icon class="pointer" color="warning" v-on="on">info</v-icon>
            </template>
            <span>{{util.tooltipMsg(7,$store.getters.tooltipBookId[bookId])}}</span>
        </v-tooltip>
    </div>
</template>

<script>

    import util from "../../utilities"

    export default {
        name: "ToolTipComponent",
        data() {
            return {
                util
            }
        },
        props: {
            bookId: Number
        }
    }
</script>

<style scoped>

    .pointer {
        cursor: pointer !important;
    }


</style>